import React from 'react';
import {
    Button, Card, Box,
    Table, TableContainer, TableHead, TableRow, TableBody
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { SmallCell } from '../style/tablecell';
import { TypographyBold, TypographyNomalBold } from '../style/typography';
import { formatteDateTimeZoneJP } from "../func/util";


const CalloutMemberList = ({ calloutUserList, unanswerUserList }) => {
    const convertWorkToText = (value) => {
        if (value === 1) return "対応可能";
        if (value === 0) return "対応不可";
        return String(value);
    };
    const convertDriveToText = (value) => {
        if (value === 1) return "運転可能";
        if (value === 0) return "運転不可";
        return String(value);
    };

    return (
        <>
            <Grid container size={{ xs: 12 }} sx={{ mt: 5 }} spacing={1}>
                <Grid size={{ xs: 12, md: 9 }}>
                    <TypographyBold sx={{ mt: 2 }}>
                        出社可否一覧
                    </TypographyBold>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Card
                        variant="outlined"
                        sx={{
                            border: '1px solid rgb(232, 234, 238)',
                            boxShadow:
                                '0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(0, 0, 0, 0.14), 0px 2px 0px 0px rgba(0, 0, 0, 0.12)',
                            marginTop: 1,
                            width: '100%',
                        }}
                    >
                        <Box sx={{ boxSizing: 'border-box' }}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <SmallCell><TypographyNomalBold>氏名</TypographyNomalBold></SmallCell>
                                            <SmallCell><TypographyNomalBold>返答日時</TypographyNomalBold></SmallCell>
                                            <SmallCell><TypographyNomalBold>出社可否</TypographyNomalBold></SmallCell>
                                            <SmallCell><TypographyNomalBold>車の運転可否</TypographyNomalBold></SmallCell>
                                            <SmallCell><TypographyNomalBold>コメント</TypographyNomalBold></SmallCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {calloutUserList.map((row) => {
                                            const isNotWorkable = row.is_workable === 0;
                                            return (
                                                <TableRow
                                                    key={row.user_uuid}
                                                    sx={isNotWorkable ? {
                                                        backgroundColor: 'rgba(0, 0, 0, 0.38)'
                                                    } : {}}
                                                >
                                                    <SmallCell>{row.full_name}</SmallCell>
                                                    <SmallCell>{formatteDateTimeZoneJP(row.replied_at)}</SmallCell>
                                                    <SmallCell>{convertWorkToText(row.is_workable)}</SmallCell>
                                                    <SmallCell>{convertDriveToText(row.is_drivable)}</SmallCell>
                                                    <SmallCell>{row.comment}</SmallCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
            {/* 未回答一覧 */}
            <Grid container size={{ xs: 12 }} sx={{ mt: 5 }} spacing={1}>
                <Grid size={{ xs: 12, md: 9 }}>
                    <TypographyBold sx={{ mt: 2 }}>
                        未回答一覧
                    </TypographyBold>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <Card
                        variant="outlined"
                        sx={{
                            border: '1px solid rgb(232, 234, 238)',
                            boxShadow: '0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 1px 0px 0px rgba(0, 0, 0, 0.14), 0px 2px 0px 0px rgba(0, 0, 0, 0.12)',
                            marginTop: 1,
                            width: '100%',
                        }}
                    >
                        <Box sx={{ boxSizing: 'border-box' }}>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <SmallCell>
                                                <TypographyNomalBold>氏名</TypographyNomalBold>
                                            </SmallCell>
                                            <SmallCell>
                                                <TypographyNomalBold>電話番号</TypographyNomalBold>
                                            </SmallCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {unanswerUserList.map((row) => (
                                            <TableRow key={row.uuid}>
                                                <SmallCell>{row.full_name}</SmallCell>
                                                <SmallCell>{row.tel}</SmallCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
};

export default CalloutMemberList;